import { render, staticRenderFns } from "./KelvinHelmholtzViz.vue?vue&type=template&id=3bd50ba9&scoped=true"
import script from "./KelvinHelmholtzViz.vue?vue&type=script&lang=js"
export * from "./KelvinHelmholtzViz.vue?vue&type=script&lang=js"
import style0 from "./KelvinHelmholtzViz.vue?vue&type=style&index=0&id=3bd50ba9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd50ba9",
  null
  
)

export default component.exports